import { SkuType } from 'types/sku';
import * as yup from 'yup';

import {
  getManufacturerDetailsValues,
  manufacturerDetailsSchema,
} from 'components/modules/SkuManufacturerDetails';

export const getInitialValues = (type: SkuType) =>
  type === 'item'
    ? {
        sku: '',
        name: '',
        itemsInCase: '',
        itemType: '',
        description: '',
        primaryColor: '',
        weight: '',
        material: '',
        manufacturer: '',
        size: '',
        pricePerDelivery: 0,
        pricePerReplacement: 0,
        qrEnabled: false,
        ...getManufacturerDetailsValues(),
      }
    : type === 'equipment'
    ? {
        name: '',
        category: '',
        manufacturer: '',
      }
    : type === 'package'
    ? {
        name: '',
        caseSku: '',
        description: '',
        washHub: '',
        items: [
          {
            sku: '',
            quantity: '',
          },
        ],
        washHubs: [],
      }
    : {
        name: '',
        prefix: '',
        description: '',
        type,
      };

export const validationSchema = (type: SkuType) => {
  if (type === 'equipment') {
    // Category and name are mandatory, manufacturer is not (ClickUp
    // 86bbmbgfc).
    return yup.object().shape({
      category: yup.string().required('Category is required'),
      name: yup.string().required('SKU Name is required'),
      manufacturer: yup.string(),
    });
  }

  if (type === 'case') {
    return yup.object().shape({
      prefix: yup.string().required('SKU Prefix is required'),
      name: yup.string().required('SKU Name is required'),
      description: yup.string(),
    });
  }

  if (type === 'package') {
    return yup.object().shape({
      name: yup.string().required('Name is required'),
      caseSku: yup.string().required('Case SKU is required'),
      description: yup.string(),
      items: yup.array(),
    });
  }

  /**
   * Item validations
   */
  return yup.object().shape({
    sku: yup.string().required('This field is required'),
    name: yup.string().required('This field is required'),
    itemsInCase: yup.string().required('This field is required'),
    itemType: yup.string(),
    description: yup.string(),
    primaryColor: yup.string(),
    weight: yup.string(),
    material: yup.string(),
    manufacturer: yup.string(),
    size: yup.string(),
    ...manufacturerDetailsSchema,
  });
};
